const key = "add-entity-translations";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const modify = (resp) => {
	resp.data.Data = {
		...resp.data.Data,
		Translations: {
			...resp.data.Data.Translations,
			"en-us": {
				"report": "ticket"
			}
		}
	};

	(resp.data.Data.Agency.Types.find(t => t.Code === "DEALER_LICENSE") ?? {}).Translations = {
		"en-us": {
			"Name": "entity",
			"Name_one": "entity(s)",
			"Name_other": "entities",
			"Labels": {
				"Code": "paul",
				"Code_one": "paul(s)",
				"Code_other": "pauls",
				"Name": "tony",
				"Name_one": "tony(s)",
				"Name_other": "tonyes",
				"ExternalKey": "key",
				"ExternalKey_one": "key(s)",
				"ExternalKey_other": "keys",
				"Classification": "Primary classification",
				"Classification_one": "attribute",
				"Classification_other": "attributes"
			}
		}
	};

	(resp.data.Data.Agency.Types.find(t => t.Code === "FISHERMAN") ?? {}).Translations = {
		"en-us": {
			"Name": "fisherman-sub",
			"Name_one": "fisherman-sub(s)",
			"Name_other": "fisherman-subs"
		}
	};

	(resp.data.Data.Agency.Types.find(t => t.Code === "VESSEL") ?? {}).Translations = {
		"en-us": {
			"Name": "vessel-sub",
			"Name_one": "vessel-sub(s)",
			"Name_other": "vessel-subs"
		}
	};

	return resp;
};

export const addEntityTranslations = [key, applicable, modify];